module.exports = __webpack_public_path__ + "static/media/183-hong-kong.f3db799d.svg";